import React, {useContext, useState} from "react";
import {DataContext} from "../../App";
import {
  Breadcrumbs,
  Container,
  Grid,
  Link as BCLink,
  Box,
  FormGroup,
  FormControlLabel,
  Checkbox,
  TextField,
  Typography,
} from "@mui/material";
import {useNavigate, Link} from "react-router-dom";
import {NavigateNext, Close} from "@mui/icons-material";
import {TbRefresh} from "react-icons/tb";
import styles from "./Styles.module.scss";
import "./Style.css";
import axios from "../../axios";
import AddressSelection from "../../components/Cart/AddressSelection";
import {useEffect} from "react";
import Quantity from "../../components/Quantity";
import {numberFormatter} from "../../formatter";
import Auth from "../../Auth";
import {Bars} from "react-loader-spinner";
import {getUserCart} from "../../components/Cart";
import {useTranslation} from "react-i18next";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

/* eslint-disable react-hooks/exhaustive-deps */

const Cart = () => {
  const {cartList, setCartList, setSnackbar} = useContext(DataContext);

  const navigate = useNavigate();
  const [addresses, setAddresses] = useState({
    invoice: [],
    delivery: [],
    ordered: [],
  });
  const [contacts, setContacts] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [isInApi, setIsInApi] = useState(false);

  const initialInputState = {
    main: {
      ordered_by_contact: Auth.getUser().MainContact,
      deliver_to_contact: Auth.getUser().MainContact,
      invoice_to_contact: Auth.getUser().MainContact,

      ordered_by_account: Auth.getUser().ID,
      deliver_to_account: Auth.getUser().ID,
      invoice_to_account: Auth.getUser().ID,

      ordered_by_address: "",
      delivery_address: "",
      invoice_to_address: "",

      your_ref: "",
      delivery_date: null,
    },
    send_order_confirmation: Auth.getUser().send_order_confirmation ?? false,
    account: {
      name: null,
      entity_type: null,
      entity_id: null,
      email: "",
      address_line_1: "",
      address_line_2: "",
      address_line_3: "",
      address_phone: "",
      address_postcode: "",
      address_country: "NL",
      address_city: "",
      address_type: "",
    },
    address: {
      address_id: null,
      address_line_1: "",
      address_line_2: "",
      address_line_3: "",
      address_phone: "",
      address_postcode: "",
      address_country: "NL",
      address_city: "",
      address_type: "",
    },
  };
  const [inputValue, setInputValue] = React.useState(initialInputState);

  useEffect(() => {
    refreshAddresses();
    refreshAccounts();

    fetchContacts().then(function (res) {
      setContacts(res);
    });
  }, []);

  useEffect(() => {
    refreshAddresses();
  }, [inputValue.main.deliver_to_account, inputValue.main.invoice_to_account]);

  const refreshAddresses = () => {
    return new Promise((resolve, reject) => {
      setAddresses({
        invoice: [],
        delivery: [],
        ordered: [],
      });
      fetchAddresses()
        .then(function (res) {
          setInputValue((prevState) => {
            let delivery = res.delivery.find((row) => {
              return row.Main === 1;
            });

            let invoice = res.invoice.find((row) => {
              return row.Main === 1;
            });

            let ordered = res.ordered.find((row) => {
              return row.Main === 1;
            });

            return {
              ...prevState,
              main: {
                ...prevState.main,
                ordered_by_address:
                  ordered?.ID ?? prevState.main.ordered_by_address,
                delivery_address:
                  delivery?.ID ?? prevState.main.delivery_address,
                invoice_to_address:
                  invoice?.ID ?? prevState.main.invoice_to_address,
                ordered_by_contact:
                  ordered?.Contact ?? prevState.main.ordered_by_contact,
                deliver_to_contact:
                  delivery?.Contact ?? prevState.main.deliver_to_contact,
                invoice_to_contact:
                  invoice?.Contact ?? prevState.main.invoice_to_contact,
              },
            };
          });

          setAddresses(res);
          resolve(res);
        })
        .catch(reject);
    });
  };

  const refreshAccounts = () => {
    fetchAccounts().then(function (res) {
      setAccounts(res);
    });
  };

  const refreshAccountsAndContacts = () => {
    return new Promise((resolve, reject) => {
      fetchAccounts()
        .then(function (res) {
          setAccounts(res);

          fetchContacts()
            .then(function (res) {
              setContacts(res);

              resolve(true);
            })
            .catch(reject);
        })
        .catch(reject);
    });
  };

  const fetchContacts = async () => {
    return await new Promise(function (resolve, reject) {
      axios
        .get("/my-account/contacts")
        .then((response) => {
          resolve(response.data.data);
        })
        .catch(reject);
    });
  };

  const fetchAddresses = async () => {
    return await new Promise(function (resolve, reject) {
      axios
        .get(
          "/my-account/addresses?invoice_account=" +
          inputValue.main.invoice_to_account +
          "&delivery_account=" +
          inputValue.main.deliver_to_account
        )
        .then((response) => {
          resolve(response.data.data);
        })
        .catch(reject);
    });
  };

  const fetchAccounts = async () => {
    return await new Promise(function (resolve, reject) {
      axios
        .get("/my-account/related-accounts")
        .then((response) => {
          resolve(response.data.data);
        })
        .catch(reject);
    });
  };

  const handleClick = (event) => {
    event.preventDefault();
    navigate(event.target.pathname);
  };

  const deleteFromCart = (event) => {
    const cartKey = event.currentTarget.getAttribute("data-cart-key");

    axios.delete("/cart/" + encodeURIComponent(cartKey)).then((response) => {
      setCartList(Object.values(response.data.cart));
    });
  };

  const formatToCurrency = (amount) => {
    const onlyNumbers = Number(String(amount).replace(/[^0-9.-]+/g, ""));
    return onlyNumbers.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
  };

  // Sum of line prices excl. VAT (cartItem.price is always excl. VAT)
  const subTotal = (status) => {
    const value = cartList.reduce((sum, cartItem) => {
      return sum + ((cartItem.price || 0) * cartItem.quantity);
    }, 0);
    return status === "formatted" ? formatToCurrency(value) : value;
  };

  // VAT grouped by percentage: { "21": 42.00, "9": 3.60, ... }
  const vatByRate = () => {
    const groups = {};
    cartList.forEach((cartItem) => {
      const product = cartItem.associatedModel;
      const pct = product.v_a_t_code?.Percentage || 0;
      const lineExcl = (cartItem.price || 0) * cartItem.quantity;
      const lineVat  = lineExcl * pct;
      const key = (pct * 100).toFixed(0); // e.g. "21", "9", "0"
      groups[key] = (groups[key] || 0) + lineVat;
    });
    return groups; // keys are percentage strings, values are VAT amounts
  };

  // Total VAT across all rates
  const vat = () => {
    return Object.values(vatByRate()).reduce((s, v) => s + v, 0);
  };

  // Grand total = subtotal excl. VAT + total VAT
  const total = () => subTotal() + vat();

  const discount = () => {
    return cartList.reduce((totalDiscount, cartItem) => {
      const basePrice = cartItem.attributes.original_price || 0;
      const effectivePrice = cartItem.price || 0;

      if (effectivePrice < basePrice) {
        const lineDiscount = (basePrice - effectivePrice) * cartItem.quantity;
        return totalDiscount + lineDiscount;
      }

      return totalDiscount;
    }, 0);
  };

  const checkOut = (event) => {
    if (
      inputValue.main.delivery_address === "" ||
      inputValue.main.invoice_to_address === "" ||
      inputValue.main.ordered_by_address === ""
    ) {
      setSnackbar({
        message: t("All address fields must be filled."),
        severity: "error",
        open: true,
      });

      return;
    }

    setIsInApi(true);

    axios
      .post("/cart/proceed", {...inputValue})
      .then((response) => {
        setSnackbar({
          message: t("Order successfully created."),
          severity: "success",
          open: true,
        });

        setCartList([]);

        navigate("/cart/thanks-for-order/" + response.data.order_number);
      })
      .catch(({response}) => {
        setSnackbar({
          message:
            response.data?.message || t("An error occured while creating order."),
          severity: "error",
          open: true,
        });

        setIsInApi(false);

        if (typeof response.data?.cart_updated != "undefined") {
          getUserCart().then(function (cart) {
            setCartList([...cart]);
          });
        }

        if (response.data?.order_number != null) {
          setCartList([]);

          navigate("/cart/thanks-for-order/" + response.data.order_number);
        }
      });
  };

  const getPrice = (product, type = "general", excludeVat = false) => {
    let price = 0;

    if (type === "general") {
      price = parseFloat(product.attributes.original_price);
    } else {
      price = parseFloat(product.price);
    }

    if (excludeVat && product.associatedModel.v_a_t_code != null) {
      let percentage = parseFloat(
        product.associatedModel.v_a_t_code.Percentage
      );

      if (product.associatedModel.v_a_t_code != null) {
        if (type !== "general") {
          price = parseFloat(product.price);
        } else {
          price = parseFloat(product.attributes.original_price);
        }

        price = price + price * percentage;
      }
    }

    return price;
  };

  const {t} = useTranslation();

  const getMinDeliveryDate = () => {
    const tomorrow = dayjs().add(1, 'day');
    if (tomorrow.day() === 6) return tomorrow.add(2, 'day');
    if (tomorrow.day() === 0) return tomorrow.add(1, 'day');
    return tomorrow;
  };

  const shouldDisableDate = (date) => {
    const day = date.day();
    return day === 0 || day === 6;
  };

  return (
    <>
      {cartList.length === 0 ? (
        <div className={styles.emptyCart}>
          <p>{t("Your cart is empty!")}</p>
        </div>
      ) : (
        <>
          <div className={styles.bg}>
            <h5>{t("Shopping Cart")}</h5>
          </div>
          <Container>
            <div className={styles.breadcrumb}>
              <div role="presentation" onClick={handleClick}>
                <Breadcrumbs
                  aria-label="breadcrumb"
                  separator={<NavigateNext fontSize="small"/>}
                  sx={{p: "14px 10px"}}
                >
                  <BCLink
                    className={styles.brdHov}
                    underline="none"
                    color="inherit"
                    href="/"
                    fontSize={"14px"}
                  >
                    {t("Home")}
                  </BCLink>
                  <BCLink
                    underline="none"
                    color="text.primary"
                    href="/cart"
                    aria-current="page"
                    fontSize={"14px"}
                  >
                    {t("Shopping Cart")}
                  </BCLink>
                </Breadcrumbs>
              </div>
            </div>
          </Container>
          <hr
            style={{
              margin: "0 0 40px",
              border: "none",
              borderBottom: "1px solid #ebebeb",
            }}
          />
          <Container sx={{pb: "50px"}}>
            <AddressSelection
              ordered={addresses.ordered}
              invoice={addresses.invoice}
              delivery={addresses.delivery}
              contacts={contacts}
              accounts={accounts}
              refreshAddresses={refreshAddresses}
              refreshAccountsAndContacts={refreshAccountsAndContacts}
              setInputValue={setInputValue}
              inputValue={inputValue}
              initialInputState={initialInputState}
            />
            <Grid container spacing={2}>
              <Grid item lg={8} xs={12} sx={{paddingLeft: "0px!important"}}>
                <Box sx={{overflowX: "auto"}}>
                  <table style={{width: "100%", borderCollapse: "collapse"}}>
                    <thead>
                      <tr style={{borderBottom: "2px solid #ececec"}}>
                        <th style={{padding: "10px 8px", textAlign: "left", fontSize: 11, textTransform: "uppercase", letterSpacing: "0.06em", color: "#999", fontWeight: 600}}>{t("Product")}</th>
                        <th style={{padding: "10px 8px", textAlign: "right", fontSize: 11, textTransform: "uppercase", letterSpacing: "0.06em", color: "#999", fontWeight: 600, width: 100}}>{t("Price")}</th>
                        <th style={{padding: "10px 8px", textAlign: "center", fontSize: 11, textTransform: "uppercase", letterSpacing: "0.06em", color: "#999", fontWeight: 600, width: 170}}>{t("Quantity")}</th>
                        <th style={{padding: "10px 8px", textAlign: "right", fontSize: 11, textTransform: "uppercase", letterSpacing: "0.06em", color: "#999", fontWeight: 600, width: 110}}>{t("Total")}</th>
                        <th style={{width: 40}}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartList.map((val) => {
                        const unitLabel = val.attributes?.unit_description
                          ? (() => {
                              const desc = val.attributes.unit_description;
                              const factor = val.attributes.number_of_items_per_unit;
                              return factor ? `${desc} — ${factor} unit${factor !== 1 ? "s" : ""} per ${desc}` : desc;
                            })()
                          : null;
                        const extra = (val.cart_extra_fields ?? []).filter(
                          (f) => f.value !== null && f.value !== undefined && f.value !== ""
                        );
                        return (
                          <tr key={val.id} style={{borderBottom: "1px solid #f1f1f1", verticalAlign: "top"}}>
                            <td style={{padding: "16px 8px"}}>
                              <div style={{fontSize: 12, color: "#9a9a9a", marginBottom: 2}}>{val.name}</div>
                              <Link
                                to={`/products/${val.attributes?.item_id ?? val.id}`}
                                style={{fontWeight: 600, color: "#1a1a1a", textDecoration: "none", lineHeight: 1.35, display: "block"}}
                              >
                                {val.associatedModel.Description}
                              </Link>
                              {unitLabel && (
                                <div style={{fontSize: 12.5, color: "#777", marginTop: 4}}>{unitLabel}</div>
                              )}
                              {extra.length > 0 && (
                                <div style={{display: "flex", flexWrap: "wrap", gap: 6, marginTop: 8}}>
                                  {extra.map((f) =>
                                    f.highlight ? (
                                      <span key={f.number} style={{fontSize: 11.5, fontWeight: 700, color: "#8a6d00", background: "#fff8e1", border: "1px solid #ffca28", borderRadius: 10, padding: "2px 9px"}}>
                                        {f.label}: {f.value}
                                      </span>
                                    ) : (
                                      <span key={f.number} style={{fontSize: 11.5, color: "#555", background: "#f4f4f4", borderRadius: 6, padding: "2px 9px"}}>
                                        {f.label}: <strong style={{color: "#333"}}>{f.value}</strong>
                                      </span>
                                    )
                                  )}
                                </div>
                              )}
                            </td>
                            <td style={{padding: "16px 8px", textAlign: "right", whiteSpace: "nowrap", color: "#333", fontSize: 14}}>
                              {numberFormatter.format(getPrice(val, "special"))}
                            </td>
                            <td style={{padding: "16px 8px", textAlign: "center"}}>
                              <Box sx={{display: "inline-flex"}}>
                                <Quantity
                                  id={val.attributes?.item_id ?? val.id}
                                  sku={val.associatedModel.Code}
                                  unitCode={val.attributes?.unit_code ?? null}
                                  isCartPage={true}
                                />
                              </Box>
                            </td>
                            <td style={{padding: "16px 8px", textAlign: "right", whiteSpace: "nowrap", fontWeight: 700, color: "#1a1a1a", fontSize: 14}}>
                              {numberFormatter.format(getPrice(val, "special") * val.quantity)}
                            </td>
                            <td style={{padding: "16px 8px", textAlign: "center"}}>
                              <button
                                onClick={deleteFromCart}
                                data-cart-key={val.id}
                                aria-label={t("Remove")}
                                style={{border: "none", background: "transparent", cursor: "pointer", color: "#bbb", display: "inline-flex", padding: 4}}
                              >
                                <Close fontSize="small"/>
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </Box>
              </Grid>
              <Grid item lg={4} xs={12}>
                <div className={styles.checkOutProcess}>
                  <div className={styles.cartDetail}>
                    <h5>{t("Cart Total")}</h5>

                    {/* Subtotal excl. VAT */}
                    <div className={styles.totalRow}>
                      <span className={styles.totalLabel}>
                        {t("Subtotal")} <small className={styles.vatNote}>{t("excl. VAT")}</small>
                      </span>
                      <span className={styles.totalValue}>{numberFormatter.format(subTotal())}</span>
                    </div>

                    {/* Discount when applicable */}
                    {discount() > 0 && (
                      <div className={styles.totalRow}>
                        <span className={styles.totalLabel}>{t("Discount")}</span>
                        <span className={styles.totalValue} style={{color: "#2e7d32"}}>
                          − {numberFormatter.format(discount())}
                        </span>
                      </div>
                    )}

                    {/* VAT per rate, sorted high to low */}
                    {Object.entries(vatByRate())
                      .filter(([, amount]) => amount > 0)
                      .sort(([a], [b]) => Number(b) - Number(a))
                      .map(([rate, amount]) => (
                        <div key={rate} className={styles.totalRow}>
                          <span className={styles.totalLabel}>
                            {t("BTW")} <small className={styles.vatNote}>{rate}%</small>
                          </span>
                          <span className={styles.totalValue}>{numberFormatter.format(amount)}</span>
                        </div>
                      ))
                    }
                    {vat() === 0 && (
                      <div className={styles.totalRow}>
                        <span className={styles.totalLabel}>
                          {t("BTW")} <small className={styles.vatNote}>0%</small>
                        </span>
                        <span className={styles.totalValue}>{numberFormatter.format(0)}</span>
                      </div>
                    )}
                  </div>

                  <div className={styles.cartDetail} style={{marginTop: 18, marginBottom: 2}}>
                    <h5>{t("Payment Method")}</h5>
                    <p>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox defaultChecked disabled/>}
                          label={t("Pay by invoice")}
                        />
                      </FormGroup>
                    </p>
                  </div>

                  <div className={styles.totalFinal}>
                    <div className={styles.totalFinalRow}>
                      <span>{t("Total")} <small className={styles.vatNote}>{t("incl. VAT")}</small></span>
                      <span>{numberFormatter.format(total())}</span>
                    </div>
                  </div>

                  {(window.storeSettings?.allow_reference_field || window.storeSettings?.allow_delivery_date_field) && (
                    <div
                      className={styles.cartDetail}
                      style={{marginTop: 18, marginBottom: 18}}
                    >
                      {window.storeSettings?.allow_reference_field && (
                        <Box sx={{ marginBottom: 2 }}>
                          <Typography variant="subtitle2" sx={{ marginBottom: 1 }}>
                            {t("Reference")}
                          </Typography>
                          <TextField
                            fullWidth
                            multiline
                            rows={2}
                            id="your_ref"
                            name="your_ref"
                            value={inputValue.main.your_ref || ""}
                            onChange={(e) => {
                              const value = e.target.value.substring(0, 200);
                              setInputValue((prevState) => ({
                                ...prevState,
                                main: {
                                  ...prevState.main,
                                  your_ref: value,
                                },
                              }));
                            }}
                            variant="outlined"
                            size="small"
                          />
                        </Box>
                      )}

                      {window.storeSettings?.allow_delivery_date_field && (
                        <Box>
                          <Typography variant="subtitle2" sx={{ marginBottom: 1 }}>
                            {t("Delivery Date")}
                          </Typography>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              value={inputValue.main.delivery_date}
                              onChange={(newValue) => {
                                setInputValue((prevState) => ({
                                  ...prevState,
                                  main: {
                                    ...prevState.main,
                                    delivery_date: newValue,
                                  },
                                }));
                              }}
                              minDate={getMinDeliveryDate()}
                              shouldDisableDate={shouldDisableDate}
                              format="DD-MM-YYYY"
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  size: "small",
                                  placeholder: "dd-mm-yyyy",
                                },
                              }}
                            />
                          </LocalizationProvider>
                        </Box>
                      )}
                    </div>
                  )}

                  {(Auth.getUserType() === 'store' || Auth.isImpersonating()) &&
                    (window.storeSettings?.order_confirmation_document_layout ||
                     window.storeSettings?.order_confirmation_email_layout) && (
                    <div className={styles.cartDetail} style={{ marginTop: 12, marginBottom: 4 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={inputValue.send_order_confirmation ?? false}
                            onChange={(e) => setInputValue((prev) => ({
                              ...prev,
                              send_order_confirmation: e.target.checked,
                            }))}
                            size="small"
                          />
                        }
                        label={<span style={{ fontSize: 14 }}>{t("Send order confirmation email")}</span>}
                      />
                    </div>
                  )}

                  <div className={styles.end}>
                    <button
                      className={`${styles.checkOutBtn}`}
                      onClick={checkOut}
                      disabled={isInApi}
                    >
                      {isInApi ? (
                        <Bars height="20" width="100%" color="#cc9966"/>
                      ) : (
                        t("Checkout")
                      )}
                    </button>
                  </div>
                </div>
                <Link to="/" className={styles.continueBtn}>
                  {t("CONTINUE SHOPPING")} <TbRefresh/>
                </Link>
              </Grid>
            </Grid>
          </Container>
        </>
      )}
      <hr
        style={{
          display: "block",
          height: "1px",
          border: "0",
          borderTop: "1px solid #ccc",
          margin: "0",
          padding: "0",
        }}
      />
    </>
  );
};

export default Cart;
